import { queryOptions } from '@tanstack/react-query';
import { listPublicKeysServerFn } from '@/server/functions/public-keys';

export const publicKeysQueryOptions = (orgSlug: string) =>
  queryOptions({
    queryKey: ['public-keys', orgSlug],
    queryFn: () => listPublicKeysServerFn({ data: { orgSlug } }),
  });
